import React from 'react';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import GuideInfoBox from '../components/GuideInfoBox';
import GuideMockChip from '../components/GuideMockChip';
import GuideMockContainer from '../components/GuideMockContainer';
import GuidePageLayout from '../components/GuidePageLayout';
import GuideSection from '../components/GuideSection';
import GuideStepList from '../components/GuideStepList';
import GuideTable from '../components/GuideTable';

const GuideClientSearch: React.FC = () => {
  return (
    <GuidePageLayout
      title="取引先を検索する"
      description="条件を指定して取引先を絞り込み検索します。"
      breadcrumbs={[{ label: '取引先管理', path: '/guide/client/overview' }]}
    >
      <GuideSection title="前提">
        <GuideTable
          headers={['条件', '内容']}
          rows={[
            ['必要な権限', '管理者 / 管理部門 / 課長'],
            ['ログイン状態', 'ログイン済みであること'],
          ]}
        />
      </GuideSection>

      <GuideSection title="手順">
        <GuideStepList
          steps={[
            { label: '取引先管理画面を開く' },
            {
              label: '検索条件を入力する（全て任意、未入力で全件検索）',
              content: (
                <GuideMockContainer label="検索条件チップ">
                  <Stack direction="row" spacing={1} flexWrap="wrap">
                    <GuideMockChip label="取引先名: サンプル" color="info" />
                    <GuideMockChip label="取引先名（カナ）: サンプル" color="info" />
                    <GuideMockChip label="取引先区分: SIer" color="secondary" />
                    <GuideMockChip label="取引終了を含む" color="default" />
                  </Stack>
                </GuideMockContainer>
              ),
            },
            { label: '「検索」ボタンを押下する' },
            { label: '検索結果が一覧表示される' },
          ]}
        />
      </GuideSection>

      <GuideSection title="検索条件">
        <GuideTable
          headers={['項目名', '形式', '検索方法', '備考']}
          rows={[
            ['取引先名', 'テキスト', '前方一致', ''],
            ['取引先名（カナ）', 'カタカナテキスト', '前方一致', ''],
            ['取引先区分', 'プルダウン', '完全一致', 'マスタ区分から選択'],
            ['取引終了を含む', 'チェックボックス', '—', 'ONで取引終了済みも表示'],
          ]}
        />
      </GuideSection>

      <GuideSection title="検索結果一覧の表示">
        <GuideTable
          headers={['表示項目', '位置', '説明']}
          rows={[
            ['取引先名', 'メイン（左）', '取引先の表示名'],
            ['取引先区分Chip', 'メイン（右）', 'マスタ区分から取得した取引先区分を表示'],
            ['取引状態Chip', 'メイン（右）', '取引中 or 取引終了を表示'],
            ['取引先名（カナ） / 担当者名', 'サブテキスト', 'カナ名と担当者名（登録がある場合）'],
          ]}
        />
        <GuideMockContainer label="リスト項目の表示例">
          <Stack spacing={1}>
            <Stack direction="row" alignItems="center" justifyContent="space-between">
              <Typography variant="body2" fontWeight={500}>
                サンプル株式会社
              </Typography>
              <Stack direction="row" spacing={0.5}>
                <GuideMockChip label="SIer" color="info" variant="outlined" size="small" />
                <GuideMockChip label="取引中" color="primary" size="small" />
              </Stack>
            </Stack>
            <Typography variant="caption" color="text.secondary">
              サンプルカブシキガイシャ / 佐藤花子
            </Typography>
          </Stack>
        </GuideMockContainer>
        <GuideTable
          headers={['Chip', '意味', '表示条件', '色']}
          rows={[
            [
              '取引先区分',
              'マスタ区分の値',
              '取引先区分が登録されている場合',
              'インデックスに応じた固定色（outlined）',
            ],
            [
              '取引中',
              '現在取引が有効',
              '取引終了日が未設定、または取引終了日が現在日以降',
              '青（primary）',
            ],
            ['取引終了', '取引が終了している', '取引終了日が現在日より前', 'グレー（default）'],
          ]}
        />
      </GuideSection>

      <GuideSection title="注意事項">
        <Stack spacing={1}>
          <GuideInfoBox>デフォルトでは取引中の取引先のみ表示されます。</GuideInfoBox>
          <GuideInfoBox>表示件数には上限があります。条件を絞って検索してください。</GuideInfoBox>
        </Stack>
      </GuideSection>
    </GuidePageLayout>
  );
};

export default GuideClientSearch;
